import {CHANGE_TOPICS, loadTopics} from 'src/pages/category/store/actions/topics';
import {selectedTopics} from 'src/pages/category/store/selectors/topics';

const documentReady = new Promise(resolve => {
  if (document.readyState === 'complete') {
    resolve();
  } else {
    document.addEventListener('readystatechange', event => {
      if (event.target.readyState === 'complete') {
        resolve();
      }
    });
  }
});

export const topics = store => {
  window.addEventListener('popstate', () => {
    const topics = selectedTopics(store.getState());
    if (`#${topics}` !== window.location.hash) {
      store.dispatch(loadTopics());
    }
  }, false);
  return next => async action => {
    next(action);
    if (action.type === CHANGE_TOPICS) {
      const topics = selectedTopics(store.getState());
      if (`#${topics}` !== window.location.hash) {
        // Wait until the document is ready before changing the hash otherwise
        // the page will scroll down to the topic.
        await documentReady;
        window.history.replaceState({}, '', `${window.location.pathname}${topics && `#${topics}`}`);
      }
    }
  };
};
